module.exports = __webpack_public_path__ + "static/media/AndroidPhone.78d1ac85.png";